import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import SendButton from "../../atoms/SendButton";
import { SEND_BUTTON_SIZES } from "../../atoms/SendButton/constants";

export default function ComposerSendButton({
  onSend,
  isBusy = false,
  canSend = false,
  size = SEND_BUTTON_SIZES.LARGE,
  className = "",
}) {
  const [isPending, setIsPending] = useState(false);

  const handleClick = useCallback(async (event) => {
    if (!onSend) {
      return;
    }
    if (!canSend || isBusy || isPending) {
      return;
    }

    setIsPending(true);
    try {
      await onSend(event);
    } catch (error) {
      console.error("Send action failed", error);
    } finally {
      setIsPending(false);
    }
  }, [onSend, canSend, isBusy, isPending]);

  const disabled = !canSend || isBusy || isPending;
  const loading = isBusy || isPending;

  return (
    <SendButton
      onClick={handleClick}
      loading={loading}
      disabled={disabled}
      size={size}
      className={className}
    />
  );
}

ComposerSendButton.propTypes = {
  onSend: PropTypes.func.isRequired,
  isBusy: PropTypes.bool,
  canSend: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SEND_BUTTON_SIZES)),
  className: PropTypes.string,
};
